import { spawn } from 'redux-saga/effects';
import watchGetPrimaryRecord from './getPrimaryRecord';

export default function* watchPrimaryRecord() {
  yield spawn(watchGetPrimaryRecord);
}
